module.exports = __webpack_public_path__ + "img/rabbit.9b78824a.svg";